export const DATA_KEYS = {
  field1: "props.metricTitle",
  contentType: "props.contentType",
  field: "props.field",
  statFunction: "props.statFunction",
  selectedFieldValue: "props.selectedFieldValue",
  selectedFieldValueNames: "props.selectedFieldValueNames",
  categoricalStatFunction: "props.categoricalStatFunction",
  countType: "props.countType",
  measureMode: "props.measureMode",
  displayMode: "props.displayMode"
};
